<div class="main">
  <spb-header/>
  <router-outlet/>
  <div [style.flex]="1"></div>
  <spb-footer
    (logoutUser)="configService.reset()"
    [license]="true"
    [token]="configService.accessToken()"
    [version]="version"
    copyrightYears="2026"
  />
</div>